import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/guanwangapi/login',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data;'
    },
  })
}
export function upload(data) {
  return request({
    url: '/guanwangapi/upload',
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'multipart/form-data;'
    },
  })
}
export function submitNews(data) {
  return request({
    url: '/guanwangapi/addNews',
    method: 'post',
    data: data,
    // headers: {
    //   'Content-Type': 'multipart/form-data;'
    // },
  })
}
export function updateNews(data) {
  return request({
    url: '/guanwangapi/editNews',
    method: 'post',
    data: data,
    // headers: {
    //   'Content-Type': 'multipart/form-data;'
    // },
  })
}
export function removeNews(id) {
  return request({
    url: '/guanwangapi/removeNews',
    method: 'get',
    params: {
      id: id
    },
    // headers: {
    //   'Content-Type': 'multipart/form-data;'
    // },
  })
}
export function getNewsList(key, pageNum, pageSize) {
  return request({
    url: '/guanwangapi/listNewsPage',
    method: 'post',
    data: {
      "keyword": key,
      "pageNum": pageNum,
      "pageSize": pageSize
    },
    // headers: {
    //   'Content-Type': 'multipart/form-data;'
    // },
  })
}
export function getNews(newsid) {
  return request({
    url: '/guanwangapi/showNews',
    method: 'get',
    params: {
      newsId: newsid
    },
    // headers: {
    //   'Content-Type': 'multipart/form-data;'
    // },
  })
}
export function getNewsImage(imageid) {
  return request({
    url: '/guanwangapi/download',
    method: 'get',
    responseType: 'blob',
    params: {
      filename: imageid
    },
    // headers: {
    //   'Content-Type': 'multipart/form-data;'
    // },
  })
}

export function getInfo(token) {
  return request({
    url: '/vue-admin-template/user/info',
    method: 'get',
    params: { token }
  })
}

export function logout() {
  return request({
    url: '/vue-admin-template/user/logout',
    method: 'post'
  })
}
